import { flow, types, getEnv, Instance } from "mobx-state-tree";
import PubSub from "pubsub-js";

import { endpoints } from "../api/ApiEndpoints";
import { api } from "../api/ApiService";
import { ApplicationError, errorHandler } from "../error-handler/ErrorHandlerService";
import { PubSubEvents } from "../PubSubEvents";
import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

export const LockedInspectionsServiceModel = types
  .model({
    lockedInspectionIds: types.optional(types.array(types.number), []),
  })
  .named("LockedInspectionsService")
  .actions((self) => {
    const addInspection = flow(function* addInspection(inspectionId: number) {
      const endpoint = endpoints.get("inspection_lock");
      endpoint.routeParams = [inspectionId];
      yield getEnv(self).api.put(endpoint);

      self.lockedInspectionIds.push(inspectionId);
    });

    const removeInspection = flow(function* removeInspection(inspectionId: number) {
      const endpoint = endpoints.get("inspection_lock");
      endpoint.routeParams = [inspectionId];
      yield getEnv(self).api.delete(endpoint);

      self.lockedInspectionIds.remove(inspectionId);
    });

    const releaseAllLockedInspections = flow(function* releaseAllLockedInspections() {
      const endpoint = endpoints.get("inspection_lock");
      for (var lockedInspectionId of self.lockedInspectionIds) {
        try {
          endpoint.routeParams = [lockedInspectionId];
          yield getEnv(self).api.delete(endpoint);
        } catch (error) {
          const applicationError = error as ApplicationError;
          errorHandler.handleErrorInSnackbar(applicationError);
        }
      }
      self.lockedInspectionIds.clear();
      PubSub.publish(PubSubEvents.AllLockedInspectionsReleased);
    });

    return {
      addInspection,
      removeInspection,
      releaseAllLockedInspections,
    };
  })
  .actions((self) => {
    return {
      async afterCreate() {
        PubSub.subscribeOnce(PubSubEvents.Logout, self.releaseAllLockedInspections);
        PubSub.subscribeOnce(PubSubEvents.BeforeUnload, self.releaseAllLockedInspections);
      },
    };
  });

export type LockedInspectionsService = Instance<typeof LockedInspectionsServiceModel>;
export const lockedInspectionsService = LockedInspectionsServiceModel.create({}, { api });

globalModule.lockedInspectionsService = lockedInspectionsService;
export default registerGlobalService(lockedInspectionsService as LockedInspectionsService);
